import type { LoyaltyOffersHubAllIndustryFilter } from './types'

export enum LoyaltyOffersHubOfferTag {
  PARTNER_OFFER = 'partner_offer',
  LUXURY_ESCAPES_OFFER = 'luxury_escapes_offer',
}

export enum LoyaltyOffersHubUrgencyType {
  NONE = 'none',
  LIMITED_TIME = 'limited_time',
  COUNTDOWN = 'countdown',
}

export const LOYALTY_OFFERS_HUB_ALL_INDUSTRY_FILTER: LoyaltyOffersHubAllIndustryFilter = 'all'
